export default __webpack_public_path__ + "static/media/speech_bubble.a74e0a26.svg";